function clean_candidate_value(value) {
  return String(value || '').trim();
}

function build_candidate_list(values = []) {
  return values.map((value) => clean_candidate_value(value));
}

function get_applicant_status_value(applicant) {
  return String(applicant?.status?.status || applicant?.status || '').trim();
}

function build_description_editor_id(sidx, dIdx, subIdx = null) {
  return subIdx === null
    ? `description_text_${sidx}_${dIdx}`
    : `sub_description_text_${sidx}_${subIdx}_${dIdx}`;
}

function build_section_payload_table(section) {
  if (!section?.use_columns) return null;
  return {
    headers: (section.table?.headers || []).map((header) => header?.label || header),
    rows: section.table?.rows || [],
  };
}


export {
  clean_candidate_value,
  build_candidate_list,
  get_applicant_status_value,
  build_description_editor_id,
  build_section_payload_table,
};

